export const GlobalSettingsTitle = 'Global Settings';
export const SettingsLabels = [
  'Gateway Budget',
  'Users Budget',
  'Prompt Optimization Configuration',
  'Gemini Key Configuration',
];
export const BudgetInputText = ['Enter Amount', 'Weekly', 'Monthly', 'Yearly'];
export const BudgetInputValue = ['weekly', 'monthly', 'yearly'];
export const SettingsNote = 'This budget excludes storage cost and code interpreter session fees.';
